module.exports = __webpack_public_path__ + "static/media/Banner-XLD Website.558d8716.jpg";